/* eslint-disable @typescript-eslint/no-unused-vars */
import { CalendarMainViewProps } from '../types/DateRangePicker.types'
import CustomDayPickerRangeController from './CustomDayPickerRangeController'

const CalendarMainView: React.FC<CalendarMainViewProps> = (props) => {
  const {
    startDate,
    endDate,
    fixedStart,
    fixedEnd,
    numberOfVisibleMonths,
    type,
    showJalaaliHolidays,
    enablePastDays,
    enableAllDays,
    onChange,
    size,
    numberOfHoveredItems,
    autoSelectedEndDate,
    range,
    multipleDates,
    dateObjectList,
    goToday,
    endDateCanBeSelectAsStartDate,
    disableBefore,
    disableAfter,
    maxRange,
    selectingStart,
    setSelectingStart
  } = props

  return (
    <div style={{ height: '100%', direction: 'ltr' }}>
      <CustomDayPickerRangeController
        {...{
          startDate,
          endDate,
          fixedStart,
          fixedEnd,
          numberOfVisibleMonths,
          showJalaaliHolidays,
          enablePastDays,
          enableAllDays,
          onChange,
          size,
          type,
          numberOfHoveredItems,
          autoSelectedEndDate,
          range,
          multipleDates,
          dateObjectList,
          goToday,
          endDateCanBeSelectAsStartDate,
          disableBefore,
          disableAfter,
          maxRange,
          selectingStart,
          setSelectingStart
        }}
      />
    </div>
  )
}

export default CalendarMainView
